module.exports = __webpack_public_path__ + "static/media/task-icon.bc571d33.jpg";